<template>
  <div class="pagination">
    <span style="">共{{total}}项数据</span>
    <a @click='changePage(false)' href="javascript:;" :class='{disabled: currentPage===1}'>上一页</a>
    <a @click="jumpPage(1)" href="javascript:;" v-if="currentPage!==1 && currentPage>3 && pages > 5">1</a>
    <span v-if='currentPage > 4 && pages > 6'>...</span>
    <a @click='changePage(item)' href="javascript:;" :class='{active: currentPage===item}' v-for='item in list' :key='item'>{{item}}</a>
    <span v-if='currentPage < pages - 2 && pages - currentPage >= 3 && pages > 5'>...</span>
    <a @click="jumpPage(pages)" href="javascript:;" v-if="pages!==currentPage && pages > 5 && pages - currentPage > 2" :class='{disabled: currentPage===pages}'>{{pages}}</a>
    <a @click='changePage(true)' href="javascript:;" :class='{disabled: currentPage===pages ||  pages<=1}'>下一页</a>
<!--    <span>总共{{pages}}页</span>-->
    <div class="jumpPage">
      <div class="input">
        跳至<input type="number" v-model="jumpPageNum">/{{pages}}页
      </div>
      <div class="button" @click="jumpPage(jumpPageNum)">跳转</div>
    </div>
  </div>
</template>
<script>
import { computed, ref } from 'vue'
export default {
  name: 'Pagination',
  props: {
    //数据总条数
    total: {
      type: Number,
      default: 0
    },
    //每页数据条数
    pageSize: {
      type: Number,
      default: 10
    },
    // 默认初始页码
    page: {
      type: Number,
      default: 1
    }
  },
  setup (props, { emit, attrs }) {
    // attrs表示父组件传递的属性，但是props没有接收的属性，这种属性不是响应式的  attrs接收父组件传递的当前页
    // console.log(props)
    // console.log(attrs,'attrs')
    const jumpPageNum = ref('')
    // 总页数
    const pages = computed(() => Math.ceil(props.total / props.pageSize))
    // 当前页码
    // console.log(attrs.page)
    // 如果父组件没有传递档当前页码，默认是第一页
    const currentPage = ref(attrs.page || props.page)
    // 动态计算页码列表
    const list = computed(() => {
      // 当父组件传递total的值发生变化时，计算属性会重新计算
      // pages = Math.ceil(props.total / props.pageSize)
      const result = []
      // 总页码小于等于5；大于5
      if (pages.value <= 5) {
        // 总页码小于等于5的情况
        for (let i = 1; i <= pages.value; i++) {
          result.push(i)
        }
      } else {
        // 总页码大于5
        if (currentPage.value <= 2) {
          // 左侧临界值
          for (let i = 1; i <= 5; i++) {
            result.push(i)
          }
        } else if (currentPage.value >= pages.value - 1) {
          // 右侧临界值
          for (let i = pages.value - 4; i <= pages.value; i++) {
            result.push(i)
          }
        } else {
          // 中间的状态
          for (let i = currentPage.value - 2; i <= currentPage.value + 2; i++) {
            result.push(i)
          }
        }
      }
      return result
    })
    // 控制上一页和下一页变化
    const changePage = (type) => {
      if (type === false) {
        // 上一页
        // 页面是第一页时，禁止点击操作
        if (currentPage.value === 1) return
        if (currentPage.value > 1) {
          currentPage.value -= 1
        }
      } else if (type === true) {
        // 下一页
        // 页面是最后页时，禁止点击操作
        if (currentPage.value === pages.value) return
        if (currentPage.value < pages.value) {
          currentPage.value += 1
        }
      } else {
        // 点击页码
        currentPage.value = type
      }
        emit('changePage', currentPage.value)
    }
    const jumpPage = (number) => {
      if (number >= 1 && number <= pages.value) {
        currentPage.value = number
        emit('changePage', currentPage.value)
      }
    }
    return { list, currentPage, pages, changePage, jumpPageNum, jumpPage }
  }
}
</script>
<style scoped lang="scss">
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0 36px;
  > a {
    display: inline-block;
    padding: 0 10px;
    border: 1px solid #DCDEE2;
    border-radius: 4px;
    margin-right: 10px;
    color: #333;
    line-height: 32px;
    &:hover {
      color: var(--main-blue-color);
      border-color: var(--main-blue-color);
    }
    &.active {
      background: var(--main-blue-color);
      color: var(--white);
      border-color: var(--main-blue-color);
    }
    &.disabled {
      cursor: not-allowed;
      opacity: 0.4;
      &:hover {
        color: #808695;
        border-color: #DCDEE2;
      }
    }
  }
  > span {
    margin-right: 10px;
    font-size: 14px;
    color: #666;
  }
  .jumpPage {
    display: flex;
    align-items: center;
    font-size: 14px;
    .input {
      background-color: #f3f3f3;
      line-height: 32px;
      padding: 0 8px;
      color: #333;
      border-radius: 3px;
      input {
        width: 60px;
        height: 30px;
        margin: 0 8px;
        border: 1px solid #DCDCDC;
        outline: none;
      }
    }
    .button {
      line-height: 30px;
      border-radius: 3px;
      background: #F3F3F3;
      border: 1px solid #DCDCDC;
      padding: 0 8px;
      cursor: pointer;
      margin-left: 24px;
    }
  }
}
</style>

